import { Component, Event, EventEmitter, getAssetPath, h, Host } from '@stencil/core';

import wcShared from '@web-components/shared';

import { Store } from '../../../../../utils/Stores/store';

@Component({
  tag: 'contact-mail-error-module',
  styleUrl: 'contact-mail-error-module.scss',
  shadow: true,
})
export class ModuleContactMailError {
  @Event() backEvent: EventEmitter;

  private back() {
    this.backEvent.emit();
  }

  render() {
    return (
      <Host>
        <div class={{ 'mail-error': true, 'mail-error--full': Store?.get('is_full') }}>
          <div class="mail-error__title">
            {wcShared?.translate('Oups...')}
            <br></br>
            {wcShared?.translate('Une erreur est survenue')}
          </div>
          <div class="mail-error__image">
            <img
              src={getAssetPath('./../assets/icons/oops_bot.svg')}
              alt={wcShared.translate('Erreur')}
            />
          </div>
          <div class="mail-error__description">
            {wcShared?.translate(
              "Il semble que nous soyons dans l'impossibilite de transmettre votre mail, merci de renouveler votre demande ulterieurement",
            )}
          </div>
          <div class="mail-error__action">
            <button onClick={() => this.back()}>{wcShared?.translate('Retour')}</button>
          </div>
        </div>
      </Host>
    );
  }
}
